import { render, staticRenderFns } from "./statisticsDialog.vue?vue&type=template&id=6cb9322b&"
import script from "./statisticsDialog.vue?vue&type=script&lang=js&"
export * from "./statisticsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb9322b')) {
      api.createRecord('6cb9322b', component.options)
    } else {
      api.reload('6cb9322b', component.options)
    }
    module.hot.accept("./statisticsDialog.vue?vue&type=template&id=6cb9322b&", function () {
      api.rerender('6cb9322b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/mawb/statisticsDialog.vue"
export default component.exports